import { render, staticRenderFns } from "./Manutencao.vue?vue&type=template&id=6a9be4ad&scoped=true"
import script from "./Manutencao.vue?vue&type=script&lang=js"
export * from "./Manutencao.vue?vue&type=script&lang=js"
import style0 from "./Manutencao.vue?vue&type=style&index=0&id=6a9be4ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9be4ad",
  null
  
)

export default component.exports